import { Controller } from "@hotwired/stimulus"

// Ein Personen-Block: natuerlich/juristisch umschalten, Handerfassung aus dem
// Modal uebernehmen, einen Eintrag entfernen.
//
// data-controller="personen-erfassung"
export default class extends Controller {
  // Beide Personenarten stehen im DOM, damit beim Umschalten nichts verloren
  // geht. Die nicht gewaehlte wird ausgeblendet und disabled -- so schickt das
  // Formular nur einen Wertsatz an dasselbe AntragPerson-Record.
  artWechseln(event) {
    const juristisch = event.target.value === "true"

    this.element.querySelectorAll("[data-personen-gruppe]").forEach((gruppe) => {
      const aktiv = (gruppe.dataset.personenGruppe === "juristisch") === juristisch
      gruppe.classList.toggle("d-none", !aktiv)
      gruppe.querySelectorAll("input, select").forEach((el) => { el.disabled = !aktiv })
      gruppe.querySelectorAll('[data-controller~="tom-select"]').forEach((el) => {
        this.tomSelect(el)?.[aktiv ? "enable" : "disable"]()
      })
    })
  }

  uebernehmen(event) {
    const slot = event.target.closest("[data-personen-slot]")
    if (!slot) return

    const wert = (feld) => (slot.querySelector(`.modal [name$="[${feld}]"]`)?.value || "").trim()
    const name = [wert("vorname"), wert("name")].filter(Boolean).join(" ")
    if (!name) return this.leeren(slot)

    this.setzeText(slot, "personen-name", name)
    this.setzeText(slot, "personen-geburt", this.geburtLabel(wert("geburtsdatum")))
    this.setzeText(slot, "personen-kontakt", [wert("kontaktperson"), wert("email")].filter(Boolean).join(" · "))

    // Eine im Suchfeld gewaehlte Person entfernen, sonst haette deren person_id
    // serverseitig Vorrang vor der Handerfassung.
    this.tomSelectVon(slot)?.clear()
    this.modus(slot, "erfasst")
  }

  // Mitbesitzer werden zum Loeschen vorgemerkt (ein bereits gespeicherter Eintrag
  // verschwindet sonst nicht), der Haupteintrag wird nur zurueckgesetzt.
  entfernen(event) {
    const slot = event.target.closest("[data-personen-slot]")
    if (!slot) return

    const zeile = slot.closest("[data-personen-zeile]")
    if (!zeile) return this.leeren(slot)

    zeile.querySelector("[data-personen-destroy]").value = "1"
    zeile.classList.add("d-none")
  }

  leeren(slot) {
    slot.querySelectorAll(".modal input").forEach((input) => { input.value = "" })
    this.tomSelectVon(slot)?.clear()
    this.modus(slot, "suche")
  }

  modus(slot, modus) {
    const erfasst = modus === "erfasst"
    slot.querySelector("[data-personen-suchfeld]")?.classList.toggle("d-none", erfasst)
    slot.querySelector("[data-personen-karte]")?.classList.toggle("d-none", !erfasst)
  }

  setzeText(slot, marker, text) {
    const ziel = slot.querySelector(`[data-${marker}]`)
    if (ziel) ziel.textContent = text
  }

  geburtLabel(iso) {
    const treffer = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso)
    return treffer ? `(${treffer[3]}.${treffer[2]}.${treffer[1]})` : ""
  }

  tomSelectVon(slot) {
    return this.tomSelect(slot.querySelector('[data-controller~="tom-select"]'))
  }

  tomSelect(element) {
    return element && this.application.getControllerForElementAndIdentifier(element, "tom-select")
  }
}
